const calculateBookingFee = (ticketPrice, admission) => {
  const gatewayRate = 0.035; // 3.5%
  const gatewayFlatFee = 2.0;
  const vat = 0.15; // 15% percent VAT

  //   const gatewayRateMultiplyAddmission = gatewayRate * admission;

  // Step 1: Estimate gateway fee
  const estimatedGatewayFee =
    ticketPrice * admission * gatewayRate + gatewayFlatFee;
  const calculateVat = estimatedGatewayFee * vat;
  const finalEstimatedGatewayFee = estimatedGatewayFee + calculateVat;

  let bookingFee = 0;
  let karamaleRate = 0;

  if (ticketPrice <= 99) {
    karamaleRate = 0.02;
  } else if (ticketPrice >= 100 && ticketPrice <= 499) {
    karamaleRate = 0.02;
  } else if (ticketPrice >= 500 && ticketPrice <= 999) {
    karamaleRate = 0.015;
  } else {
    karamaleRate = 0.015;
  }

  const desiredMargin = ticketPrice * karamaleRate * admission;
  bookingFee = desiredMargin;
  let previousFee = 0;
  let iterations = 0;
  let gatewayFee = 0;
  //  bookingFee = ticketPrice * karamaleRate;

  while (iterations < 10 && Math.abs(bookingFee - previousFee) > 0.01) {
    previousFee = bookingFee;
    const totalAmount = ticketPrice * admission + bookingFee;
    gatewayFee = (totalAmount * gatewayRate + gatewayFlatFee) * (1 + vat);
    bookingFee = desiredMargin + gatewayFee;
    iterations++;
  }

  const bookingFeeAdmission = desiredMargin;
  const totalBookingFees = parseFloat(bookingFee.toFixed(2));

  return {
    bookingFeeAdmission: Number(bookingFeeAdmission),
    karamaleRate: Number(karamaleRate),
    estimatedGatewayFee: Number(estimatedGatewayFee),
    finalEstimatedGatewayFee: Number(gatewayFee),
    gatewayFlatFee: Number(gatewayFlatFee),
    gatewayRate: Number(gatewayRate),
    totalBookingFees: Number(totalBookingFees),
    vat: Number(vat),
  };
  //   return Math.round(totalFees);
};

export default calculateBookingFee;
